import { MarketingWorkFile } from "@/bryntum-lib/models/MarketingWorkFile";
import { Button } from "@/modern/components/ui/button-shadcn";
import { Globe } from "lucide-react";
import { useMarketingPageGenerate } from "@/react/components/entityViews/marketingPages/hooks/useMarketingPageGenerate";

interface PublishMarketingPageActionProps {
  file: MarketingWorkFile;
}

export function PublishMarketingPageAction({ file }: PublishMarketingPageActionProps) {
  const { generating, startGenerateForWorkFile } = useMarketingPageGenerate();
  const disabled = file.archived || generating;

  return (
    <Button
      type="button"
      size="sm"
      variant="outline"
      className="h-8 min-h-8 shrink-0 gap-1 px-3 text-xs"
      disabled={disabled}
      onClick={() => startGenerateForWorkFile(Number(file.id))}
      title={
        file.archived
          ? "Unarchive this work file to publish."
          : "Publish a hosted marketing page from this work file"
      }
    >
      <Globe className="size-3.5" aria-hidden />
      Publish page
    </Button>
  );
}
